import { IDimensions } from './dimensions';

export interface IOrderTaskPost {
  activityTypeAbbreviation?: string;
  activityTypeDescription?: string;
  activityTypeId?: number;
  activityTypeType?: string;
  approvedById?: number;
  approvedByName?: string;
  approvedBySecondaryId?: number;
  approvedBySecondaryName?: string;
  articleDescription?: string;
  articleId?: number;
  articleNumber?: string;
  bearerDescription?: string;
  costEach?: number;
  costTypeDescription?: string;
  costTypeId?: number;
  costTypeIndex?: number;
  createdAt?: Date;
  createdById?: number;
  createdByName?: string;
  departmentDescription?: string;
  description?: string;
  dimensions?: IDimensions;
  documentCount?: number;
  fiscalDateDays?: number;
  fiscalDateDaysFriendly?: Date;
  fiscalSetupId?: number;
  id?: number;
  isApproved?: boolean;
  note?: string;
  orderContextType?: string;
  orderId?: number;
  orderLineArticleGroupDescription?: string;
  orderLineArticleGroupId?: number;
  orderLineArticleId?: number;
  orderLineArticleNumber?: number;
  orderLineId?: number;
  orderLineQuantity?: number;
  orderLineUnitAbbreviation?: string;
  orderLineUnitId?: number;
  orderLineWeight?: number;
  orderNumber?: number;
  orderTaskAbbreviation?: string;
  orderTaskDescription?: string;
  orderTaskId?: number;
  orderTaskIndex?: number;
  orderTaskStatusId?: number;
  projectId?: number;
  purposeDescription?: string;
  quantity?: number;
  resourceId?: number;
  resourceName?: string;
  responsibleId?: number;
  responsibleName?: string;
  salesPrice?: number;
  total?: number;
  type?: string;
  unitAbbreviation?: string;
  unitId?: number;
  version?: number;
  voucherId?: number;
  voucherNumber?: number;
}
